import {
  normalizeClassifications,
  type Classifications,
  type DsmScopeItem
} from "design-scope";

/**
 * When every selected row shares the same classification, return it for
 * bulk-edit prefill; otherwise undefined (mixed / empty).
 */
export function sharedClassification(
  rows: DsmScopeItem[]
): Classifications | undefined {
  if (rows.length === 0) return undefined;
  const first = normalizeClassifications(rows[0]?.classification) ?? null;
  for (let i = 1; i < rows.length; i += 1) {
    const next = normalizeClassifications(rows[i]?.classification) ?? null;
    if (JSON.stringify(next) !== JSON.stringify(first)) return undefined;
  }
  return first ?? undefined;
}

/** Which classification slots the bulk edit should overwrite. */
export type BulkReplaceClassificationFlags = {
  replaceUf: boolean;
  replaceMf: boolean;
  replaceCustom: boolean;
};

/**
 * Per-row classification for bulk update: replaced slots come from the draft;
 * untouched slots keep the row's existing values so blanks never wipe them.
 * Custom replace is exclusive — it applies the draft label only.
 */
export function mergeBulkClassificationUpdate(
  existing: Classifications | undefined,
  draft: Classifications | undefined,
  flags: BulkReplaceClassificationFlags
): Classifications | undefined {
  if (flags.replaceCustom) {
    return normalizeClassifications({ label: draft?.label });
  }
  return normalizeClassifications({
    uf: flags.replaceUf ? draft?.uf : existing?.uf,
    mf: flags.replaceMf ? draft?.mf : existing?.mf
  });
}
